import React from 'react';
import { CustomChipStyled } from './custom-chip.styled';

export interface CustomChipProps {
  onClick?: () => void;
  label: string;
  styleContainer?: any;
  styleLabel?: any
}

const CustomChip = (props: CustomChipProps) => {

  return (
    <CustomChipStyled.Container onClick={props.onClick} style={ {...props.styleContainer && props.styleContainer, cursor: props.onClick ? 'pointer' : 'initial' }}>
      <CustomChipStyled.Label style={props.styleLabel && props.styleLabel}>{props.label}</CustomChipStyled.Label>
    </CustomChipStyled.Container>
  );
};

export default CustomChip;
